export default __webpack_public_path__ + "static/media/hashexLogo.37b4d8c1.svg";